import { MAPS_API_KEY } from "../../config/Constant";

/**
 * Loads the Google Maps API script if it is not already loaded.
 *
 * @return {HTMLScriptElement | boolean} The script element for the Google Maps API, or false if it is already loaded.
 */
export const loadMapApi = () => {
  const mapsURL = `https://maps.googleapis.com/maps/api/js?key=${MAPS_API_KEY}&libraries=places%2Cgeometry%2Cdrawing%2Cvisualization`;
  const scripts = document.getElementsByTagName("script");
  // Go through existing script tags, and return google maps api tag when found.
  for (let i = 0; i < scripts.length; i++) {
    if (scripts[i].src === mapsURL) {
      return scripts[i];
    }
    if (scripts[i].src.indexOf(mapsURL) === 0) {
      return false; //scripts[i];
    }
  }

  const googleMapScript = document.createElement("script");
  googleMapScript.src = mapsURL;
  googleMapScript.async = true;
  googleMapScript.defer = true;
  window.document.body.appendChild(googleMapScript);

  return googleMapScript;
};
